import PropTypes from 'prop-types';
import React from 'react';
import { injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { compose } from 'redux';
import { createStructuredSelector } from 'reselect';
import styled from 'styled-components';
import { BaseComponent } from '../../../components/BaseComponent';
import { FormField } from '../../../components/FormFields';
import { Button } from '../../../components/Buttons';
import { Input } from '../../../components/Input';
import { Search, Times } from '../../../components/Icon';
import { changeInvoiceFilter } from '../actions';

const Container = styled.div``;

const STATE = {
  search: '',
};
/* eslint-disable react/prefer-stateless-function */
class InvoiceSearchRegplateComp extends BaseComponent {
  constructor(props) {
    super(props, {
      ...STATE,
      search: props.filter.regplate || '',
    });
  }

  componentDidMount() {}

  reset() {
    this.setState({ ...STATE }, this.doSearch);
  }

  doSearch() {
    this.props.setSearchString(this.state.search);
  }

  handleKeyPress = event => {
    if (event.key === 'Enter') {
      this.props.setSearchString(this.state.search);
    }
  };

  searchStringChangeHandler() {
    this._t = this.timeout(
      () => {
        this.props.setSearchString(this.state.search);
      },
      600,
      this._t,
    );
  }

  render() {
    return (
      <Container>
        <FormField label={this.lblStr('invoice.search.regplate')}>
          <Input
            name="search"
            value={this.state.search}
            leftDecoration={<Search />}
            rightDecoration={
              <div
                style={{ opacity: this.state.search?.length ? '1' : '0', padding: '0 12px' }}
                onClick={this.reset.bind(this)}
              >
                <Times />
              </div>
            }
            onChange={evt => {
              this.setState({ search: evt.target.value });
            }}
            onKeyPress={this.handleKeyPress}
          />
          <Button small={window.innerWidth <= 768} onClick={this.doSearch.bind(this)}>Zoeken</Button>
        </FormField>
      </Container>
    );
  }
}

InvoiceSearchRegplateComp.propTypes = {
  dispatch: PropTypes.func.isRequired,
};

const mapStateToProps = (state, ownProps) => createStructuredSelector({});

function mapDispatchToProps(dispatch, ownProps) {
  return {
    dispatch,
    setSearchString(string) {
      dispatch(changeInvoiceFilter('regplate', string));
    },
  };
}

const withConnect = connect(
  mapStateToProps,
  mapDispatchToProps,
);

export const InvoiceSearchRegplate = compose(
  withConnect,
  withRouter,
  injectIntl,
)(InvoiceSearchRegplateComp);
